import React from 'react';
import { StyleSheet } from './base_components';

import ProgressSpinner from './progress_spinner';
import Select from './select';

import VolumeStore from '../stores/volume_store';
import { useOrg } from '../stores/user_store';

const styles = StyleSheet.create({
  volumeSelect: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    color: 'var(--input-text-color)',
    fontSize: '1.5rem',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: 'var(--input-border-color)',
    backgroundColor: 'var(--input-bg-color)',
  },
  spinner: {
    margin: '1rem',
    width: '2rem',
    height: '2rem',
  },
});
export default function VolumeSelect(props) {
  const { excludeList, user, excludeDisabled } = props;
  const org = useOrg();
  const volume_list = VolumeStore.useVolumeList(org?.org_id);
  React.useEffect(() => {
    VolumeStore.fetch(org?.org_id);
  }, [org?.org_id]);

  function _onChange(new_value) {
    props.onChange(parseInt(new_value));
  }

  let content: any = null;
  if (!volume_list) {
    content = <ProgressSpinner style={styles.spinner} color='#999' />;
  } else {
    const valid_list = volume_list.filter((volume) => {
      const { volume_id, org_id, is_disabled } = volume;
      let ret = !is_disabled;
      if (excludeList) {
        const excluded = excludeList.find((v) => v.volume_id === volume_id);
        if (excluded) {
          ret = false;
        }
      }
      if (user) {
        const found = user.org_list.find((o) => o.org_id === org_id);
        if (!found) {
          ret = false;
        }
      }
      if (excludeDisabled && volume.is_disabled) {
        ret = false;
      }
      return ret;
    });
    valid_list.sort(_sortVolume);

    const options = [
      ...valid_list.map((v) => ({
        value: v.volume_id,
        text: v.volume_name,
      })),
    ];
    content = (
      <Select
        style={[styles.volumeSelect, props.style]}
        placeholder={props.placeholder}
        options={options}
        value={props.value > 0 ? String(props.value) : ''}
        onChange={_onChange}
      />
    );
  }
  return content;
}
function _sortVolume(a, b) {
  return a.volume_name.localeCompare(b.volume_id);
}
